import ApiCore from './api-core'
import { ACTIVE_BASE_REST } from './constants'

export default class UserAccount extends ApiCore {
  constructor(store) {
    super(store, `${ACTIVE_BASE_REST}/account`)
  }

  loginStatus(filter) {
    return this._request({
      action: 'status',
      method: 'GET',
      params: filter
    })
  }

  updateNotificationSession(notificationToken) {
    return this._request({
      action: 'session/notification',
      method: 'PUT',
      body: {
        notificationToken
      }
    })
  }

  getPermissionsList() {
    return this._request({
      action: 'permission/list',
      method: 'GET'
    })
  }

  logout(showProgress) {
    return this._request({
      action: 'logout',
      method: 'delete',
      showProgress
    })
  }
}
